import React from 'react';
import {
    Stack,
    IconButton,
} from '@mui/material';
import { IconPencil, IconTrash, IconEye } from '@tabler/icons';
import MyDataGrid from '../../../common/components/MyDataGrid';

const columns = [
    { field: 'name', headerName: 'Group Name', width: 200, flex: 1},
    {
        field: 'actions',
        headerName: 'Actions',
        sortable: false,
        width: 210,
        headerAlign: 'center',
        renderCell: (params) => {
            return  (
                <Stack direction="row" spacing={1} sx={{m: "auto"}}>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            params.row.actions.onEdit(params.row.uuid);
                        }}>
                        <IconPencil />
                    </IconButton>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            params.row.actions.onDelete(params.row.uuid);
                        }}>
                        <IconTrash />
                    </IconButton>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            params.row.actions.onView(params.row.uuid);
                        }}>
                        <IconEye />
                    </IconButton>
                </Stack>
            );
        }
    },
];

export default function ReferralGroupsTable({
    onFilterChanged,
    onAdd,
    onDelete,
    onEdit,
    onSelectedRowsChanged,
    loading,
    data,
}) {
    return (
        <MyDataGrid
            onFilterChanged={onFilterChanged}
            onAdd={onAdd}
            addButtonText="Create Referral Group"
            onDelete={onDelete}
            onEdit={onEdit}
            onSelectedRowsChanged={onSelectedRowsChanged}
            loading={loading}
            data={data}
            columns={columns}
            getRowId={(row) => {
                return row.id;
            }}
            minTableHeight={'calc(100vh - 232px)'}
        />
    );
}
